import { Record } from 'immutable';

const {
    AI_SUMMARY_REQUEST,
    AI_SUMMARY_SUCCESS,
    AI_SUMMARY_FAILURE,
    AI_QUESTION_REQUEST,
    AI_QUESTION_SUCCESS,
    AI_QUESTION_FAILURE,
    AI_CLEAR_CHAT,
    AI_INCREMENT_REQUEST_COUNT,
    AI_RESET_HOURLY_COUNT,
    AI_RESET_DAILY_COUNT,
} = require('./aiActions').constants;

const InitialState = Record({
    isLoadingSummary: false,
    isLoadingAnswer: false,
    summary: '',
    chatHistory: [],
    error: null,
    // Rate limiting
    hourlyRequestCount: 0,
    dailyRequestCount: 0,
    lastHourlyReset: Date.now(),
    lastDailyReset: Date.now(),
});

const initialState = new InitialState();

// Rate limits - configurable via environment variables
// Default: 10/hour, 50/day | For testing: set lower values in .env
export const HOURLY_LIMIT = parseInt(process.env.REACT_APP_AI_HOURLY_LIMIT, 10) || 10;
export const DAILY_LIMIT = parseInt(process.env.REACT_APP_AI_DAILY_LIMIT, 10) || 50;
export const QUESTION_LIMIT = parseInt(process.env.REACT_APP_AI_QUESTION_LIMIT, 10) || 3;

export default function aiReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.merge(state);

    switch (type) {
    case AI_SUMMARY_REQUEST:
        return state.set('isLoadingSummary', true)
            .set('error', null);
    case AI_SUMMARY_SUCCESS:
        return state.set('isLoadingSummary', false)
            .set('summary', payload)
            .set('error', null);
    case AI_SUMMARY_FAILURE:
        return state.set('isLoadingSummary', false)
            .set('error', payload);

    case AI_QUESTION_REQUEST:
        return state.set('isLoadingAnswer', true)
            .set('error', null);
    case AI_QUESTION_SUCCESS:
        // append message to chatHistory. payload should be {id, question, answer}
        return state.set('isLoadingAnswer', false)
            .set('chatHistory', state.get('chatHistory').concat([payload]))
            .set('error', null);
    case AI_QUESTION_FAILURE:
        return state.set('isLoadingAnswer', false)
            .set('error', payload);

    case AI_CLEAR_CHAT:
        return state.set('chatHistory', [])
            .set('summary', '')
            .set('error', null);

    case AI_INCREMENT_REQUEST_COUNT:
        return state
            .set('hourlyRequestCount', state.get('hourlyRequestCount') + 1)
            .set('dailyRequestCount', state.get('dailyRequestCount') + 1);

    case AI_RESET_HOURLY_COUNT:
        return state
            .set('hourlyRequestCount', 0)
            .set('lastHourlyReset', Date.now());

    case AI_RESET_DAILY_COUNT:
        return state
            .set('dailyRequestCount', 0)
            .set('lastDailyReset', Date.now());

    default:
        return state;
    }
}
